var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('span', { staticClass: "iconLanguage" }, [_c('span', { staticClass: "flag" }, [_vm._v(_vm._s(_vm.icon))]), _vm._v("\n  " + _vm._s(' ') + _vm._s(_vm.showCode ? _vm.language.code : _vm.language.name) + "\n")]);
};
var staticRenderFns = [];

export { render, staticRenderFns };